(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('MonitorWordsController', MonitorWordsController);

  /* ngInject */
  function MonitorWordsController($state, Flash, monitorWordService, sessionService) {
    const vm = this;

    vm.deleteMonitorWord = deleteMonitorWord;
    vm.monitorWords = [];

    activate();

    function activate() {
      getMonitorWords();
    }

    function deleteMonitorWord(monitorWord) {
      monitorWordService(sessionService.getAuthToken()).destroy({ id: monitorWord.id }, _ => {
        $state.reload();
        Flash.create('success', 'Monitor word successfully deleted.');
      });
    }

    function getMonitorWords() {
      monitorWordService(sessionService.getAuthToken()).query(response => {
        vm.monitorWords = response;
      });
    }
  }
})();
